<template>
  <div v-if="zsmInfo">
    <div class="panel panel-default">
      <div class="panel-heading">
        {{
          [
            zsmInfo.storeInfo &&
              zsmInfo.storeInfo.customerInfo &&
              zsmInfo.storeInfo.customerInfo.name,
            zsmInfo.storeInfo && zsmInfo.storeInfo.name,
          ]
            .filter((item) => !!item)
            .join(" ")
        }}
      </div>
      <table class="table table-striped">
        <tbody>
          <tr>
            <th style="width: 90px">入库时间</th>
            <td colspan="3">
              {{
                new Date(zsmInfo.inboundTime).format("YYYY-MM-dd hh:mm:ss") ||
                ""
              }}
            </td>
          </tr>
          <tr>
            <th style="width: 90px">扫码人员</th>
            <td colspan="3">
              {{ zsmInfo.inboundHandleBy || "" }}
            </td>
          </tr>
          <template v-if="zsmInfo.outboundTime > 0">
            <tr>
              <th style="width: 90px">出库时间</th>
              <td colspan="3">
                {{
                  new Date(zsmInfo.outboundTime).format(
                    "YYYY-MM-dd hh:mm:ss"
                  ) || ""
                }}
              </td>
            </tr>
            <tr>
              <th style="width: 90px">扫码人员</th>
              <td colspan="3">
                {{ zsmInfo.outboundHandleBy || "" }}
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
  </div>
</template>


<script>
export default {
  props: {
    zsmInfo: {
      type: Object,
    },
    simpleMode: {
      type: Boolean,
      default: false,
    },
  },
}
</script>